import { Menu } from "../models/menu.model";

export const MENU: Array<Menu> = [
  {
    exact: true,
    icon: 'dashboard',
    route: '/dashboard',
    title: 'Dashboard',
    rolesCanAccess: ['sudo'],
  },
  {
    icon: 'home',
    route: 'neighborhoods',
    title: 'Colonias',
    rolesCanAccess: ['admin', 'sudo'],
  },
  {
    icon: 'category',
    title: 'Catálogos',
    rolesCanAccess: ['sudo'],
    children: [
      {
        icon: '',
        title: 'Paqueterías',
        route: 'catalogues/parcel-services',
      },
      {
        icon: '',
        title: 'Tipos de colonias',
        route: 'catalogues/neighborhood-types',
      },
      {
        icon: '',
        title: 'Tipos de cuentas bancarias',
        route: 'catalogues/bank-account-types',
      },
      {
        icon: '',
        title: 'Tipos de grupos de acceso',
        route: 'catalogues/access-door-group-types',
      },
      {
        icon: '',
        title: 'Tipos de puertas de acceso',
        route: 'catalogues/access-door-types',
      },
      {
        icon: '',
        title: 'Tipos de pruebas',
        route: 'catalogues/proof-types',
      },
      {
        icon: '',
        title: 'Tipos de notificaciones',
        route: 'catalogues/notification-types',
      },
      {
        icon: '',
        title: 'Métodos de pago',
        route: 'catalogues/payment-methods',
      },
      {
        icon: '',
        title: 'Tipos de tags',
        route: 'catalogues/tag-types',
      },
      {
        icon: '',
        title: 'Tipos de visita',
        route: 'catalogues/visit-types',
      },
    ]
  },
  {
    icon: 'support_agent',
    route: 'platforms',
    title: 'Soporte',
    rolesCanAccess: ['sudo'],
  },
  {
    icon: 'receipt_long',
    route: 'external-service-logs',
    title: 'Bitácora servicios ext.',
    rolesCanAccess: ['sudo'],
  },
  {
    icon: 'hub',
    route: 'mcp',
    title: 'MCP',
    rolesCanAccess: ['sudo'],
  },
  {
    icon: 'security',
    title: 'Seguridad',
    rolesCanAccess: ['sudo'],
    children: [
      {
        icon: '',
        title: 'Módulos',
        route: 'security/modules',
      },
      {
        icon: '',
        title: 'Perfiles',
        route: 'security/profiles',
      },
      {
        icon: '',
        title: 'Usuarios',
        route: 'security/users',
      },
      
    ]
  }
];

export const MENU_NEIGH: Array<Menu> = [
  {
    exact: true,
    icon: 'dashboard',
    route: ':neighborhoodId',
    title: 'Dashboard',
    rolesCanAccess: ['admin', 'sudo'],
  },
  // {
  //   icon: 'person',
  //   route: ':neighborhoodId/settlers',
  //   title: 'Colonos',
  // },
  {
    icon: 'security',
    route: ':neighborhoodId/administrators',
    title: 'Administradores',
    rolesCanAccess: ['sudo'],
  },
  {
    icon: 'security',
    route: ':neighborhoodId/guards',
    title: 'Vigilantes',
    rolesCanAccess: ['sudo'],
  },
  {
    icon: 'payments',
    route: ':neighborhoodId/payments',
    title: 'Cuotas',
    rolesCanAccess: ['admin', 'sudo'],
  },
  {
    icon: 'account_balance_wallet',
    route: ':neighborhoodId/movements',
    title: 'Movimientos',
    rolesCanAccess: ['admin', 'sudo'],
  },
  {
    icon: 'weekend',
    route: ':neighborhoodId/amenities',
    title: 'Amenidades',
    rolesCanAccess: ['admin', 'sudo'],
  },
  {
    icon: 'menu_book',
    route: ':neighborhoodId/bookings',
    title: 'Reservaciones',
    rolesCanAccess: ['admin', 'sudo'],
  },
  // {
  //   icon: 'person',
  //   route: ':neighborhoodId/houses-flats',
  //   title: 'Colonos',
  //   rolesCanAccess: ['admin', 'sudo'],
  // },
  {
    icon: 'house',
    route: ':neighborhoodId/streets-buildings',
    title: 'Casas',
    rolesCanAccess: ['admin', 'sudo'],
  },
  {
    icon: 'confirmation_number',
    route: ':neighborhoodId/visits',
    title: 'Visitas',
    rolesCanAccess: ['admin', 'sudo'],
  },
  {
    icon: 'style',
    route: ':neighborhoodId/passes',
    title: 'Pases',
    rolesCanAccess: ['admin', 'sudo'],
  },
  {
    icon: 'article',
    route: ':neighborhoodId/announcements',
    title: 'Anuncios',
    rolesCanAccess: ['admin', 'sudo'],
  },
  {
    icon: 'gavel',
    route: ':neighborhoodId/notice-violations',
    title: 'Amonestaciones',
    rolesCanAccess: ['admin', 'sudo'],
  },
  {
    icon: 'assignment',
    route: ':neighborhoodId/reports',
    title: 'Reportes',
    rolesCanAccess: ['admin', 'sudo'],
  },
  {
    icon: 'inventory',
    route: ':neighborhoodId/packages',
    title: 'Paquetes',
    rolesCanAccess: ['admin', 'sudo'],
  },
  {
    icon: 'videocam',
    route: ':neighborhoodId/cameras',
    title: 'Cámaras',
    rolesCanAccess: ['sudo', 'admin'],
  },
  {
    icon: 'door_sliding',
    route: ':neighborhoodId/gates',
    title: 'Accesos',
    rolesCanAccess: ['sudo'],
  },
  {
    icon: 'ballot',
    route: ':neighborhoodId/surveys',
    title: 'Encuestas',
    rolesCanAccess: ['admin', 'sudo'],
  },
  {
    icon: 'assignment',
    title: 'Bitacoras',
    rolesCanAccess: ['admin', 'sudo'],
    children: [
      {
        icon: '',
        title: 'Botón de emergencia',
        route: ':neighborhoodId/logs/sos',
        rolesCanAccess: ['admin', 'sudo'],
      },
      {
        icon: '',
        title: 'Servicios externos',
        route: ':neighborhoodId/logs/external-services',
        rolesCanAccess: ['sudo'],
      }
    ]
  },
  {
    icon: 'settings',
    title: 'Configuración',
    children: [
      {
        icon: '',
        title: 'Módulos',
        route: ':neighborhoodId/settings/modules',
        rolesCanAccess: ['sudo'],
      },
      {
        icon: '',
        title: 'Perfiles',
        route: ':neighborhoodId/settings/profiles',
        rolesCanAccess: ['sudo'],
      },
      {
        icon: '',
        title: 'Tipos de prueba',
        route: ':neighborhoodId/settings/proof-types',
        rolesCanAccess: ['sudo'],
      },
      {
        icon: '',
        title: 'Cuentas bancarias',
        route: ':neighborhoodId/settings/bank-accounts',
        rolesCanAccess: ['admin', 'sudo'],
      },
      {
        icon: '',
        title: 'Número de emergencia',
        route: ':neighborhoodId/settings/emergency-numbers',
        rolesCanAccess: ['admin', 'sudo'],
      },
      {
        icon: '',
        title: 'Servicios',
        route: ':neighborhoodId/settings/services',
        rolesCanAccess: ['admin', 'sudo'],
      },
      {
        icon: '',
        title: 'Reglamentos',
        route: ':neighborhoodId/settings/rules',
        rolesCanAccess: ['admin', 'sudo'],
      },
      {
        icon: '',
        title: 'General',
        route: ':neighborhoodId/settings/general',
        rolesCanAccess: ['admin', 'sudo'],
      },
      {
        icon: '',
        // rolesCanAccess es obligatorio en los hijos: neighborhood-layout
        // filtra con child.rolesCanAccess!.includes(...) y un hijo sin esta
        // propiedad truena en runtime con TypeError.
        title: 'Dirección',
        route: ':neighborhoodId/settings/address',
        rolesCanAccess: ['sudo'],
      },
      {
        icon: '',
        title: 'Pases',
        route: ':neighborhoodId/settings/passes',
        rolesCanAccess: ['admin', 'sudo'],
      },
      {
        icon: '',
        title: 'Pagos',
        route: ':neighborhoodId/settings/payments',
        rolesCanAccess: ['admin', 'sudo'],
      },
      // {
      //   icon: '',
      //   title: 'Usuarios',
      //   route: ':neighborhoodId/settings/users',
      //   rolesCanAccess: ['admin', 'sudo'],
      // },

    ]
  }
];